import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';
import { useAsync } from 'react-use';
import { TAXONOMY_PATH_DELIMITER } from '@uno/common-cms';
import { TERM_HIERARCHY_DISPLAY_SEPARATOR } from 'config/constants';
import { getTaxonomyTerms } from 'services/networking/taxonomy';

var buildTitle = function buildTitle(term, mapping) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var title = "".concat(term.label).concat(suffix === '' ? '' : "".concat(TERM_HIERARCHY_DISPLAY_SEPARATOR).concat(suffix));

  if (!term.isHierarchical) {
    return title;
  }

  var paths = term.path.split(TAXONOMY_PATH_DELIMITER);

  if (paths.length < 2) {
    return title;
  }

  var parentId = paths[paths.length - 1];
  var parent = mapping.find(function (_term) {
    return _term.id === parentId;
  });

  if (parent === undefined) {
    return title;
  }

  return buildTitle(parent, mapping, title);
};

var termsToOptions = function termsToOptions(terms) {
  var options = terms.map(function (term) {
    return {
      title: buildTitle(term, terms),
      id: term.id
    };
  });
  return sortBy(options, 'title');
};

var useTaxonomyTagOptions = function useTaxonomyTagOptions(name) {
  var _useAsync = useAsync( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getTaxonomyTerms(name);

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [name]),
      loading = _useAsync.loading,
      error = _useAsync.error,
      value = _useAsync.value;

  var options = useMemo(function () {
    return termsToOptions(value !== null && value !== void 0 ? value : []);
  }, [value]);
  return {
    loading: loading,
    error: error,
    options: options
  };
};

export default useTaxonomyTagOptions;